import { render, staticRenderFns } from "./Jeu.vue?vue&type=template&id=1ad16c28&"
import script from "./Jeu.vue?vue&type=script&lang=js&"
export * from "./Jeu.vue?vue&type=script&lang=js&"
import style0 from "./Jeu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports